import { useState } from "react";
import { Plus } from "lucide-react";
import { accommodationFaqs } from "@/data/resort";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function AccommodationsFAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section
      id="accommodations-faq"
      aria-labelledby="acc-faq-heading"
      className="bg-background py-16 md:py-20"
    >
      <div className="shell grid gap-8 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <Reveal>
            <Eyebrow>Good to Know</Eyebrow>
          </Reveal>
          <h2 id="acc-faq-heading" className="display-lg mt-6 lg:sticky lg:top-28">
            <MaskReveal>Questions About</MaskReveal>
            <MaskReveal delay={0.08}>Our RV Sites?</MaskReveal>
          </h2>
        </div>

        <dl className="lg:col-span-8">
          {accommodationFaqs.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div key={faq.q} className="border-b border-border first:border-t">
                <dt>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    aria-controls={`acc-faq-panel-${i}`}
                    className="flex w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <span className="font-display text-lg tracking-tight md:text-xl">{faq.q}</span>
                    <Plus
                      className={`size-5 shrink-0 text-primary transition-transform duration-500 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                      strokeWidth={1.5}
                    />
                  </button>
                </dt>
                <dd id={`acc-faq-panel-${i}`} hidden={!isOpen}>
                  <p className="max-w-2xl pb-8 text-sm leading-relaxed text-muted-foreground">
                    {faq.a}
                  </p>
                </dd>
              </div>
            );
          })}
        </dl>
      </div>
    </section>
  );
}
